module.exports = __webpack_public_path__ + "static/media/NewPOPLogo.da0ebaf7.png";